import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';




@Pipe({
    name: 'LgvUTCDate'
})
export class LgvUTCDatePipe2 implements PipeTransform {

    constructor(public DP: DatePipe) { }

    /*
     * Converts date to a UTC date so the standard DatePipe converts it to local time.
     */

    transform(origDate: Date) {
        return origDate == null ? null : new Date(this.DP.transform(origDate, 'yyyy/MM/dd HH:mm') + ' UTC');
    }
}
